// extracted by mini-css-extract-plugin
export default {"productGallery":"TH-z","inQuickShop":"UH-z"};